/**
 * InboxGroupingToggle — Conversazioni hub axis switch (``Per thread`` ⇄
 * ``Per messaggio``).
 *
 * Thin wrapper around :class:`SegmentedToggle` (`@ando/ui`). Twin of
 * :class:`GroupingModeToggle` (documents) — same primitive, different
 * vocabulary.
 */

import { Layers, ListChecks } from "lucide-react";
import * as React from "react";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { SegmentedToggle } from "@ando/ui";

import {
  INBOX_GROUPING_LABELS,
  INBOX_GROUPING_MODES,
  type InboxGroupingMode,
} from "../utils/threadGroup";


export interface InboxGroupingToggleProps {
  readonly value: InboxGroupingMode;
  readonly onChange: (next: InboxGroupingMode) => void;
  readonly className?: string;
}


export const InboxGroupingToggle: React.FC<InboxGroupingToggleProps> = ({
  value,
  onChange,
  className,
}) => {
  const { i18n } = useLingui();
  const options = React.useMemo(
    () =>
      INBOX_GROUPING_MODES.map((id) => ({
        id,
        label: i18n._(INBOX_GROUPING_LABELS[id]),
        icon:
          id === "thread" ? (
            <Layers size={12} strokeWidth={2} aria-hidden />
          ) : (
            <ListChecks size={12} strokeWidth={2} aria-hidden />
          ),
      })),
    [i18n],
  );
  return (
    <SegmentedToggle<InboxGroupingMode>
      value={value}
      onChange={onChange}
      options={options}
      ariaLabel={i18n._(msg`Modalità di raggruppamento conversazioni`)}
      className={className}
    />
  );
};
InboxGroupingToggle.displayName = "InboxGroupingToggle";
